/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      UNAVAILABLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Estás solicitando un cambio de velocidad que no tienes disponible',
          msg: ['Si has solicitado el cambio hace pocos minutos es posible que la información no esté todavía actualizada.','Para conocer el estado real de tu pedido accede al seguimiento de pedidos de tu área cliente.'],
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              link: URLS.URL_TRACKING_CO,
              label: "Ver mis pedidos",
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'cambio de velocidad no disponible - sin cisi',
        },
      },
      ALREADY_HIRED_EQUIPMENT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Ya dispones de la velocidad solicitada',
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              label: "Volver a movistar.es",
              link: URLS.HOME,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto ya contratado',
        },
      },
      UNAVAILABLE_OR_ALREADY_HIRED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Estás solicitando un cambio de velocidad que no tienes disponible',
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              label: "Volver a movistar.es",
              link: URLS.HOME,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con parque o ya contratado',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
